import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M12 14v-1h.001L12 14zm-.001-1H4V8h8l-.001 5zm1.002-6.721v-.315c0-2.737-2.243-4.964-5-4.964C6.412 1 4.954 1.724 4 2.985c-.333.442-.246 1.069.194 1.402.441.333 1.067.245 1.402-.195C6.168 3.435 7.045 3 8.001 3c1.654 0 3 1.329 3 2.964V6H4c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V8c0-.736-.404-1.374-.999-1.721z"
        />
        <path
          className="icon-color"
          d="M9.002 9.81c0-.554-.449-1.002-1.002-1.002-.554 0-1.002.448-1.002 1.002 0 .295.133.554.335.736v.93c0 .372.3.672.671.672.369 0 .67-.3.67-.671v-.935c.199-.183.328-.44.328-.732"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M18 18.997c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v7zm.004-9.814V8c0-3.31-2.692-6.001-6-6.001-2.417 0-4.586 1.439-5.527 3.665-.215.509.022 1.096.531 1.31.508.215 1.096-.023 1.31-.531C8.946 4.96 10.393 4 12.004 4c2.206 0 4 1.795 4 4v.997H7c-1.654 0-3 1.346-3 3v7c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-7c0-1.301-.837-2.4-1.996-2.814z"
        />
        <path
          className="icon-color"
          d="M13.5 14.494c0-.83-.672-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .443.196.838.502 1.112v1.384c0 .554.449 1.003 1.004 1.003.554 0 1.003-.45 1.003-1.003v-1.392c.3-.275.491-.666.491-1.104"
        />
      </g>
    </svg>
  ),
};
